// @flow

import './index.scss';
import * as React from 'react';
import classnames from 'classnames';

type Props = {|
    props: any,
    isDragged: boolean,
    children: React.Node
|};

const Thumb = ({ props, isDragged, children }: Props): React.Node => (
    <div
        {...props}
        className={classnames('RangeThumb', { 'RangeThumb--drag': isDragged })}
        style={props.style}
    >
        {children}
    </div>
);

export default Thumb;
